import React, { useState } from "react";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";

import { Form, Field } from "react-final-form";
import arrayMutators from "final-form-arrays";
// @ts-ignore
import createDecorator from "final-form-focus";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import Grid from "@material-ui/core/Grid";

// @ts-ignore
import {
  TextField,
  Checkbox as CheckboxFieldRender,
} from "final-form-material-ui";

import { FieldArray, FieldArrayRenderProps } from "react-final-form-arrays";

import WidgetOverview from "./widget-overview";

import UserSelectField from "./user-select-field";

import GroupSelectField from "./group-select-field";

import MenuItem from "@material-ui/core/MenuItem";

import SelectFieldRender from "./select-field-render";

import FormControlLabel from "@material-ui/core/FormControlLabel";

const focusOnErrors = createDecorator();

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
  })
);

interface Props {
  saveEntity: any;
  entity?: any;
  defaultValues?: any; // TODO entityCreateContainerGenerator
  cancelEdit?: any;
}

function DashboardCreate(props: Props) {
  const { saveEntity, entity /*, defaultValues*/ } = props; // TODO entityCreateContainerGenerator
  const { cancelEdit } = props;
  const classes = useStyles(props);

  const validate = (values: any) => {
    const errors = {} as any;

    // TODO also subfields! (like widget layout)
    if (
      !(
        "title" in values &&
        values.title !== undefined &&
        values.title !== null
      )
    ) {
      errors.title = "Required";
    }
    return errors;
  };

  const [
    tabIndex7d6147e6Eb754d05A0d079c76e7effa5,
    setTabIndex7d6147e6Eb754d05A0d079c76e7effa5,
  ] = useState(0);

  function handleTabChange7d6147e6Eb754d05A0d079c76e7effa5(
    event: any,
    newValue: number
  ) {
    setTabIndex7d6147e6Eb754d05A0d079c76e7effa5(newValue);
  }

  return (
    <Form
      onSubmit={saveEntity}
      decorators={[focusOnErrors]}
      initialValues={entity}
      mutators={{
        ...arrayMutators,
      }}
      validate={validate}
      render={({ handleSubmit, pristine, invalid, submitting }) => (
        <form onSubmit={handleSubmit}>
          <>
            <Grid container spacing={1}>
              {/* Hide ID */}
            </Grid>
            <Tabs
              value={tabIndex7d6147e6Eb754d05A0d079c76e7effa5}
              onChange={handleTabChange7d6147e6Eb754d05A0d079c76e7effa5}
              variant="scrollable"
              scrollButtons="on"
            >
              <Tab label="General" />
              <Tab label="Security" />
            </Tabs>

            {tabIndex7d6147e6Eb754d05A0d079c76e7effa5 === 0 && (
              <Grid container spacing={1}>
                <Grid item xs={12} md>
                  <Field
                    name="title"
                    type="text"
                    component={TextField}
                    label="Title"
                    // margin="normal"
                    required
                    autoFocus
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <FieldArray name="widgets">
                    {({
                      fields /*, meta*/,
                    }: FieldArrayRenderProps<any, any>) => (
                      <div>
                        {/* TODO entity.widgets must not be hardcoded! => use variant -> options -> widget[s]Field, e.g.:
                  const parentSymbol = field.scope; // or args.field.scope
                  const options = parentSymbol.annotationMap.options
                    ? parentSymbol.annotationMap.variant.options
                    : undefined;
                  const widgetField = options ? options.widgetField : undefined;
                   */}
                        <WidgetOverview
                          entity={entity}
                          arrayHelpers={fields}
                          fields={fields.value}
                        />
                      </div>
                    )}
                  </FieldArray>
                </Grid>
              </Grid>
            )}
            {tabIndex7d6147e6Eb754d05A0d079c76e7effa5 === 1 && (
              <>
                <fieldset>
                  <legend>Ownership</legend>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md>
                      <Field
                        name="owner"
                        component={UserSelectField}
                        label="Owner"
                        fullWidth
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md>
                      <Field
                        name="group"
                        component={GroupSelectField}
                        label="Group"
                        fullWidth
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </fieldset>
                <fieldset>
                  <legend>Privileges</legend>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md>
                      <Field
                        name="permissionOwner"
                        component={SelectFieldRender}
                        label="Permission Owner"
                        fullWidth
                        formControlProps={{
                          fullWidth: true,
                        }}
                      >
                        <MenuItem value="READWRITE">Readwrite</MenuItem>
                        <MenuItem value="READ">Read</MenuItem>
                        <MenuItem value="NONE">None</MenuItem>
                      </Field>
                    </Grid>
                    <Grid item xs={12} md>
                      <Field
                        name="permissionGroup"
                        component={SelectFieldRender}
                        label="Permission Group"
                        fullWidth
                        formControlProps={{
                          fullWidth: true,
                        }}
                      >
                        <MenuItem value="READWRITE">Readwrite</MenuItem>
                        <MenuItem value="READ">Read</MenuItem>
                        <MenuItem value="NONE">None</MenuItem>
                      </Field>
                    </Grid>
                    <Grid item xs={12} md>
                      <Field
                        name="permissionOther"
                        component={SelectFieldRender}
                        label="Permission Other"
                        fullWidth
                        formControlProps={{
                          fullWidth: true,
                        }}
                      >
                        <MenuItem value="READWRITE">Readwrite</MenuItem>
                        <MenuItem value="READ">Read</MenuItem>
                        <MenuItem value="NONE">None</MenuItem>
                      </Field>
                    </Grid>
                  </Grid>
                </fieldset>
                <fieldset>
                  <legend>Availability</legend>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <FormControlLabel
                        label="Public Available"
                        control={
                          <Field
                            name="publicAvailable"
                            component={CheckboxFieldRender}
                            type="checkbox"
                          />
                        }
                      />
                    </Grid>
                  </Grid>
                </fieldset>
              </>
            )}
          </>
          <Button
            variant="contained"
            className={classes.button}
            color="primary"
            type="submit"
            disabled={submitting || invalid}
          >
            Submit
          </Button>
          {cancelEdit && (
            <Button
              variant="contained"
              className={classes.button}
              onClick={cancelEdit}
            >
              Cancel
            </Button>
          )}
        </form>
      )}
    />
  );
}

export default DashboardCreate;
